import axios from "axios";
import { getAuthorizationHeaders, handleUnauthorized } from "./session";

const UseFetch = async (method, url, abortController = new AbortController(), params) => {
  const signal = abortController.signal;
  const config = {
    headers: getAuthorizationHeaders(),
  };

  try {
    const request = axios[method.toLowerCase()](
      url,
      ...(method.toLowerCase() === "get" ? [{ ...config, signal }] : [params, { ...config, signal }])
    );
    const response = await request;
    return response;
  } catch (error) {
    handleUnauthorized(error);
    throw error;
  }
};

export default UseFetch;
